import { ReactElement } from 'react';
import { Badge, Box, Button, Popover } from '@ff-it/ui';
import { Link } from 'react-router-dom';
import { useMembership } from 'services';
import { CampaignChip } from 'modules/campaign/campaign/CampaignChip';
import type { ListCampaign } from 'modules/campaign/campaign/types';

interface InvoiceSourceProps {
  className?: string;
  source_avb?: number | null;
  source_campaigns?: ListCampaign[];
  source_cvb?: number | null;
}

export function InvoiceSource({
  source_campaigns,
  source_avb,
  source_cvb,
  className,
}: InvoiceSourceProps): ReactElement | null {
  const { slug } = useMembership();
  if (source_campaigns?.length) {
    if (source_campaigns.length === 1) {
      const [source_campaign] = source_campaigns;
      return (
        <Button asChild variant="ghost" size="xs" icon="paper-plane" className={className}>
          <Link to={`/${slug}/planning/campaigns/${source_campaign.id}/planning`} title="Campaign" />
        </Button>
      );
    }
    return (
      <Badge count={source_campaigns.length} variant="secondary">
        <Popover
          content={
            <Box display="flex" flexDirection="column" gap="1" p="1">
              {source_campaigns.map((source_campaign) => (
                <CampaignChip key={source_campaign.id} campaign={source_campaign} />
              ))}
            </Box>
          }
        >
          <Button variant="ghost" size="xs" icon="paper-plane" className={className} title="Campaigns" />
        </Popover>
      </Badge>
    );
  }
  if (source_avb) {
    return (
      <Button asChild variant="ghost" size="xs" icon="handshake" className={className}>
        <Link to={`/${slug}/guarantee/avb/${source_avb}`} title="AVB" />
      </Button>
    );
  }
  if (source_cvb) {
    return (
      <Button asChild variant="ghost" size="xs" icon="handshake" className={className}>
        <Link to={`/${slug}/guarantee/cvb/${source_cvb}`} title="CVB" />
      </Button>
    );
  }
  return null;
}
